<template>
  <v-container grid-list-md>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <h1>Title: {{project.title}}</h1>
            <v-spacer></v-spacer>
            <v-btn @click="back" color="btnColor" flat>Back</v-btn>

            <v-btn icon :to="`/expert/create/video_project?id=${project._id}`">
              <v-icon color="orange">edit</v-icon>
            </v-btn>
            <v-btn icon @click="deleteModal">
              <v-icon color="red">delete</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm12>                
                <p class="font-weight-bold">Description: <div v-html="project.description"></div></p>
              </v-flex>
              <v-flex xs12 sm12 v-if="project.active == true">
                <h4>Project Status: <span class="font-weight-regular">{{project.status}}</span></h4>
              </v-flex>
              <v-flex xs12 sm12 v-if="project.active == false">
                <h4>Project Status: <span class="font-weight-regular" style="color: red;"> Deactivated</span>, 
                  <a href="javascript:void(0)" @click="showContactModal" >Contact Support</a></h4>
              </v-flex>
              <v-flex xs12 sm12>
                <h4>Category: <span class="font-weight-regular">{{project.category}}</span></h4>
              </v-flex>
              <v-flex xs12 sm12 v-if="project.location">
                <h4 v-if="project.location">Location: <span class="font-weight-regular">{{project.location.locationName}}</span></h4>
              </v-flex>
              <v-flex xs12 sm12>
                <h4>Posted On: <span class="font-weight-regular">{{project.createdAt | moment("DD MMMM YYYY") }}</span></h4>
              </v-flex>
              <v-flex xs12 sm12 v-if="project.videos">
                <hr>
                <label>Videos</label>
              </v-flex>
              <v-flex v-if="project.videos"  xs12 sm3 v-for="(video, index) in project.videos" v-bind:key="'v'+index">
                <video :src="`${host}/uploads/video_projects/video/${video}`" style="max-width:100%; height:auto" controls=""></video>
              </v-flex>

              <v-flex xs12 class="pa-2" v-if="reviews && reviews.length>=1">
                <h5 class="mb-3">Reviews ({{reviewAmount}})</h5>
                <v-layout wrap v-if="reviews.length>=1">
                  <v-flex xs12 v-for="review in reviews" v-bind:key="review._id" class="mb-4">
                    <span class="green--text text--darken-1" 
                      v-if="review.sonkoId"
                    >{{review.sonkoId.firstName}} {{review.sonkoId.lastName}}</span>
                    <span class="green--text text--darken-1" v-else>{{review.username}}</span>
                    <br>
                    <i>{{review.review}}</i>
                    <br>
                    <v-rating
                      v-bind:value="Math.round(review.rating)"
                      color="yellow darken-3"
                      background-color="grey darken-1"
                      empty-icon="$vuetify.icons.ratingFull"
                      half-increments
                      hover
                      readonly
                    ></v-rating>
                    <a href="javascript:void(0)" @click="showReportModal(review._id)" >
                      Report the review for moderation…
                    </a>
                  </v-flex>
                  <v-flex>
                    <v-pagination 
                      v-model="currentPage"
                      :length="Math.ceil(reviewAmount/perPage)"
                      @input="onPageChange"
                  ></v-pagination>
                </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions></v-card-actions>
        </v-card>
      </v-flex>

      <!-- delete dialog -->
      <v-dialog v-model="delete_dialog" max-width="600px">
        <v-toolbar class="primary" dark dense>
          <v-toolbar-title>Delete project</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="delete_dialog=false">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card>
          <v-layout wrap>
            <v-flex xs12 class="pa-2">
              <h3>Are you sure you want to delete this project?</h3>
            </v-flex>
            <v-flex xs12>
              <v-btn color="red" class="right" small dark @click="deleteProject">
                <v-icon left>delete</v-icon>Yes
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-dialog>
      <!-- end of delete  -->

      <!-- image modal -->
      <v-dialog v-model="imageDialog" max-width="1200px">
        <v-card>
          <v-toolbar flat dense color="light-blue" dark>
            <v-toolbar-title class="title">Image preview</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon class="mb-2" @click.native="closeImage">
              <v-icon>clear</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text>
            <v-layout wrap>
              <v-flex xs12>
                <img class="modal-img" :src="`${host}/uploads/video_projects/${currentImage}`">
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- end of image modal -->

      <!-- contact support modal -->
      <v-dialog v-model="contactModal" max-width="500px">
        <v-card>
          <v-toolbar color="primary" flat dense dark>
            <v-toolbar-title class="title">Contact Support</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="mx-0" icon @click.native="contactModal=false">
              <v-icon color="white">clear</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12>
                <a :href="`https://wa.me/254777221441`" target="_blank">
                  <img src="@/assets/whatsapp.png" style="width: 40px; height: 40px;" alt="">
                </a>
              </v-flex>
              <v-flex xs12>
                  <span class="hidden-sm-and-down" style="color: #03a9f4"><v-icon class="green--text text--darken-1">phone</v-icon> +254777221441</span><a class="hidden-md-and-up pl-2" href="tel:+254777221441"><v-icon class="green--text text--darken-1">phone</v-icon> +254777221441</a>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- contact support modal -->

      <!-- report review modal -->
      <v-dialog v-model="reportModal" max-width="500px">
        <v-card>
          <v-toolbar color="primary" flat dense dark>
            <v-toolbar-title class="title">Report Review</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="mx-0" icon @click.native="reportModal=false">
              <v-icon color="white">clear</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12>
                <v-textarea v-model="report_review" label="Description"></v-textarea>
              </v-flex>
              <v-flex xs12>
              <v-btn color="btnColor" small dark @click="reportReview">
                <v-icon>save</v-icon>save
              </v-btn>
            </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- report review modal -->

    <app-snackbar ref="mySnackbar"></app-snackbar>  
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ProjectDetailsComponent",
  computed: {
    ...mapGetters(["host"]),
    ...mapGetters(["user"])
  },
  props: {
    project: {
      type: Object,
      default: {}
    },
    coverMedia: {
      type: Array,
      default: []
    }
  },
  components: {},
  data() {
    return {
      delete_dialog: false,
      reviews: [],
      imageDialog: false,
      currentImage: null,
      reviewAmount: 0,
      currentPage: typeof this.$route.query.page != "undefined" ? this.$route.query.page : 1,
      perPage: 8,
      reportModal: false,
      contactModal: false,
      report_review: null,
      reviewId: 0
    };
  },
  watch: {
    "$route.params.id": {
      handler: "projectReviews",
      immediate: true
    }
  },
  methods: {
    showReportModal(id) {
      this.reviewId = id;
      this.reportModal = true;
    },
    showContactModal() {
      this.contactModal = true;
    },
    showImage(img) {
      this.currentImage = img;
      this.imageDialog = true;
    },
    closeImage() {
      this.imageDialog = false;
    },
    deleteModal() {
      this.delete_dialog = true;
    },
    projectReviews(id) {
      let cPage = typeof this.$route.query.page != "undefined"
        ? this.$route.query.page
        : 1;
      const self = this;
      const res = this.$store
        .dispatch("get", "/review/videoproject/" + id+"/"+cPage)
        .then(res => {
          self.reviews = res.reviews;
          self.reviewAmount = res.amount;
          self.currentPage = cPage;
        });
    },
    deleteProject() {
      const self = this;
      const res = this.$store
        .dispatch("remove", "/videoproject/" + this.user._id + '/' + this.project._id)
        .then(res => {
         this.$router.push("/expert/video_projects");
        });
    },
    back() {
      this.$router.push("/expert/video_projects");
    },
    onPageChange(page) {
      this.$router.push({query: {page: page}});
      this.projectReviews(this.$route.params.id);
    },
    reportReview() {
      const data = {
        report_review: this.report_review,
        is_report: 1
      };

      const self = this;
      const res = this.$store
        .dispatch("put", { url: "/review/videoproject/"+this.reviewId, data })
        .then(res => {
          self.$refs.mySnackbar.show("Report Review Successful", "blue");
          self.reportModal = false;
        });
    }
  }
};
</script>


<style scoped>
p {
  font-size: 16px;
}
</style>
